export default function Devchip(){

    return(
        <p className="myportfolio-chip myportfolio-devchip">
            DEV
        </p>
    )
}